export default "__VITE_ASSET__Dk_r5x9X__"